import React from 'react';
import BaseModal from '../BaseModal';
import { modalNames } from '../../../../shared/configs/modal';
import { lifeCycleEntitiesMap } from '../../constants';
import SelectStage from '../SelectStage';
import { useChangeRoomStageMutation } from '../../../../api/changeRoomStage';
import { useAcceptanceViewFlatsInvalidate } from '../../../../api/acceptanceViewFlats';

const ChangeStageModal = () => {
  const invalidateFlats = useAcceptanceViewFlatsInvalidate();

  const { mutateAsync, isLoading } = useChangeRoomStageMutation({
    onSuccess: () => {
      invalidateFlats();
    },
  });

  const getOnSubmit = ({ closeModal }) => {
    return async (values) => {
      await mutateAsync(values);
      closeModal();
    };
  };

  return (
    <BaseModal
      name={modalNames.changeRoomStage}
      getInitialValue={getInitialValue}
      getOnSubmit={getOnSubmit}
      entity={lifeCycleEntitiesMap.stage}
      confirmLoading={isLoading}
    >
      <SelectStage />
    </BaseModal>
  );
};

export default ChangeStageModal;

function getInitialValue(room, lifeCycleState) {
  return typeof lifeCycleState === 'object'
    ? lifeCycleState?.stage?.id
    : room?.stageAddressLifeCycle?.id;
}
